import React, { useEffect } from "react";
import "../assets/css/north.css";
import hero1 from "../assets/TIG Website Images/About Us/dfdsfdf.png";
import about1 from "../assets/TIG Website Images/About Us/dfdsfdf.png"; 
import about2 from "../assets/TIG Website Images/About Us/asas.png";
import about3 from "../assets/TIG Website Images/About Us/aaa.png";
import about4 from '../assets/TIG Website Images/About Us/About TIG.png'
import AOS from "aos";
import "aos/dist/aos.css";
import '../assets/css/home.css'

const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <div className="container-fluid p-0">
       <div
  className="hero-section"
  style={{ backgroundImage: `url(${hero1})` }}
>
          <div className="carousel-caption d-flex flex-column align-items-center justify-content-center text-center h-100">
            <div className="col-lg-10 zoom-in-text">
              <h1 className="display-4 fw-bold text-light mb-4 animated slideInDown">
                About Us
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div className="container-fluid px-md-5 px-3 my-5">
        <div className="row">
          {/* Left Content */}
          <div className="col-lg-8" data-aos="fade-up">
            <h4 className="fw-bold mb-3">
              Towers International Group of companies 
            </h4>
            <p className="para-about">
             Towers International Group of companies was established in 1999, an Omani owned Small and Medium Enterprise Company. It has a strong connection in Muscat Region of  Oman, through its founder and owner Mr. Ahmed Qadir Al Balushi, Ex- Banker.
            </p>
            <p className="para-about">
             The staffs are committed individuals and are capable to hold responsibility, give care and attention; thus rendered efficient service to all our valued clients over last 2 decades. As the demand of new infrastructure,  petrochemicals and tourism projects in Oman arise thus the diversifications to new activities. Traditionally banking and financial services provide, the company intends to build on this solid foundation to widen itsrange ofservices to increasingly respond to new opportunities in the region.
            </p>
            {/* <p className="para-about">
                The company continues to develop its range of activities and services to meet the modern needs of Oman in particular to contribute to the achievements of His Majesty The Sultan Haitham Bin Tariq vision for SME Developments and training
young Omani’sfor financialservices in general.
            </p> */}
            <img
              src={about2}
              alt="about-1"
              className="img-fluid rounded shadow mb-4 about-img"
            />
            <p className="para-about">
             Our mission is to build strong & sustainable resources capable to deliver to our clients reliable high quality outsourced professionals with the background of high
quality deliverable with global standard diversified banking experiences and advance IT planning & solutions and product marketing.
            </p>
            <p className="para-about">
             We always strive to be known as provider of highly-competent and success-driven manpower. In the realm of global labor environment, we will continue to do our best to provide our clients with the best available manpower whose professional skills, competencies and work ethics are at par with some of the best in either local
market or overseas.

            </p>
           
          </div>
    {/* Right Sidebar */}
<div className="col-lg-4 mt-3 mt-md-0" data-aos="fade-up">

  {/* Accordion Q&A */}
  <div className="accordion  mb-4" id="faqAccordion">

    {/* Q1 */}
    <div className="accordion-item mb-2">
      <h2 className="accordion-header" id="headingOne">
        <button className="accordion-button fw-bold" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
          What is Towers International Group ?
        </button>
      </h2>
      <div id="collapseOne" className="accordion-collapse collapse show"
        aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
        <div className="accordion-body">
          Towers International Group of companies was established in 1999 and provides high quality staffing solutions...
        </div>
      </div>
    </div>

    {/* Q2 */}
    <div className="accordion-item mb-2">
      <h2 className="accordion-header" id="headingTwo">
        <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
          What services do you provide ?
        </button>
      </h2>
      <div id="collapseTwo" className="accordion-collapse collapse"
        aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
        <div className="accordion-body">
          We provide manpower outsourcing, technical support, and consultancy services tailored to client requirements.
        </div>
      </div>
    </div>

    {/* Q3 */}
    <div className="accordion-item mb-2">
      <h2 className="accordion-header" id="headingThree">
        <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
          How can I contact you ?
        </button>
      </h2>
      <div id="collapseThree" className="accordion-collapse collapse"
        aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
        <div className="accordion-body">
          You can reach us via the contact form below or call our office directly for inquiries.
        </div>
      </div>
    </div>

    {/* Q4 */}
    <div className="accordion-item mb-2">
      <h2 className="accordion-header" id="headingFour">
        <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
          Where are you located ?
        </button>
      </h2>
      <div id="collapseFour" className="accordion-collapse collapse"
        aria-labelledby="headingFour" data-bs-parent="#faqAccordion">
        <div className="accordion-body">
          Our headquarters is in Oman, and we operate across multiple regions.
        </div>
      </div>
    </div>

    {/* Q5 */}
    <div className="accordion-item mb-2">
      <h2 className="accordion-header" id="headingFive">
        <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
          What industries do you serve ?
        </button>
      </h2>
      <div id="collapseFive" className="accordion-collapse collapse"
        aria-labelledby="headingFive" data-bs-parent="#faqAccordion">
        <div className="accordion-body">
          We serve industries like oil & gas, construction, IT, and general manpower outsourcing.
        </div>
      </div>
    </div>

    {/* Q6 */}
    <div className="accordion-item mb-2">
      <h2 className="accordion-header" id="headingSix">
        <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
          How to apply for a job ?
        </button>
      </h2>
      <div id="collapseSix" className="accordion-collapse collapse"
        aria-labelledby="headingSix" data-bs-parent="#faqAccordion">
        <div className="accordion-body">
          You can submit your resume through our careers page or send it via email to our HR department.
        </div>
      </div>
    </div>

    {/* Q7 */}
    <div className="accordion-item mb-2">
      <h2 className="accordion-header" id="headingSeven">
        <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
          Do you provide overseas recruitment ?
        </button>
      </h2>
      <div id="collapseSeven" className="accordion-collapse collapse"
        aria-labelledby="headingSeven" data-bs-parent="#faqAccordion">
        <div className="accordion-body">
          Yes, we specialize in overseas manpower supply for multiple industries.
        </div>
      </div>
    </div>

    {/* Q8 */}
    <div className="accordion-item mb-2">
      <h2 className="accordion-header" id="headingEight">
        <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
          Do you offer consultancy services ?
        </button>
      </h2>
      <div id="collapseEight" className="accordion-collapse collapse"
        aria-labelledby="headingEight" data-bs-parent="#faqAccordion">
        <div className="accordion-body">
          Yes, we provide consultancy in staffing, compliance, and business operations.
        </div>
      </div>
    </div>

    {/* Q9 */}
    <div className="accordion-item mb-2">
      <h2 className="accordion-header" id="headingNine">
        <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
          What is your recruitment process ?
        </button>
      </h2>
      <div id="collapseNine" className="accordion-collapse collapse"
        aria-labelledby="headingNine" data-bs-parent="#faqAccordion">
        <div className="accordion-body">
          Our recruitment process involves screening, interviewing, and selecting qualified candidates as per client requirements.
        </div>
      </div>
    </div>

    {/* Q10 */}
    <div className="accordion-item mb-2">
      <h2 className="accordion-header" id="headingTen">
        <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
          Do you provide training for candidates ?
        </button>
      </h2>
      <div id="collapseTen" className="accordion-collapse collapse"
        aria-labelledby="headingTen" data-bs-parent="#faqAccordion">
        <div className="accordion-body">
          Yes, we arrange skill development and training programs based on industry needs.
        </div>
      </div>
    </div>

    {/* Q11 */}
    <div className="accordion-item mb-2">
      <h2 className="accordion-header" id="headingEleven">
        <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven">
          How long does recruitment take ?
        </button>
      </h2>
      <div id="collapseEleven" className="accordion-collapse collapse"
        aria-labelledby="headingEleven" data-bs-parent="#faqAccordion">
        <div className="accordion-body">
          It depends on the project size, but typically placements are done within 2–4 weeks.
        </div>
      </div>
    </div>

    {/* Q12 */}
    <div className="accordion-item">
      <h2 className="accordion-header" id="headingTwelve">
        <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseTwelve" aria-expanded="false" aria-controls="collapseTwelve">
          Do you provide post-recruitment support ?
        </button>
      </h2>
      <div id="collapseTwelve" className="accordion-collapse collapse"
        aria-labelledby="headingTwelve" data-bs-parent="#faqAccordion">
        <div className="accordion-body">
          Yes, we offer ongoing support and assistance to both clients and candidates after recruitment.
        </div>
      </div>
    </div>

  </div>

  {/* Contact Form */}
  {/* <div className="card shadow p-4">
    <h5 className="fw-bold mb-3">Message</h5>
    <form>
      <div className="mb-3">
        <input type="text" className="form-control" placeholder="Name" />
      </div>
      <div className="mb-3">
        <input type="email" className="form-control" placeholder="Email" />
      </div>
      <div className="mb-3">
        <input type="text" className="form-control" placeholder="Subject" />
      </div>
      <div className="mb-3">
        <textarea className="form-control" rows="4" placeholder="Message"></textarea>
      </div>
      <div className="d-flex text-center justify-content-center">
        <button type="submit" className="btn-submit w-50">Submit</button>
      </div>
    </form>
  </div> */}
   {/* <img
              src={about1}
              alt="about-1"
              className="img-fluid rounded shadow mb-4 mt-4"
              style={{height:"390PX",width:"410px"}}
            /> */}
</div>


        </div>
         <div className="d-flex gap-3">
              <img
                src={about4}
                alt="about-2"
                className="img-fluid rounded shadow"
                style={{ maxWidth: "48%" }}
              />
              <img
                src={about3}
                alt="about-3"
                className="img-fluid rounded shadow"
                style={{ maxWidth: "48%" }}
              />
            </div>
      </div>
      
    </div>
  );
};

export default About;
